export enum ADJUSTMENT_TYPE {
    FREE = 100,
    CPM = 0,
    CPC,
}